/**
 * @generated SignedSource<<b5b7368db70be9c1abb8edce04694a01>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductizedServiceTabs_productizedService$data = {
  readonly deliverables: {
    readonly count: number;
  };
  readonly userProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"useSafeUserReviews_userProfile">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceDeliverables_productizedService" | "ProductizedServiceDescription_productizedService" | "ProductizedServiceExampleProjects_productizedService" | "ServicePageReviews_productizedService">;
  readonly " $fragmentType": "ProductizedServiceTabs_productizedService";
};
export type ProductizedServiceTabs_productizedService$key = {
  readonly " $data"?: ProductizedServiceTabs_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductizedServiceTabs_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductizedServiceTabs_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServiceDeliverableConnection",
      "kind": "LinkedField",
      "name": "deliverables",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "count",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useSafeUserReviews_userProfile"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceDescription_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceExampleProjects_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductizedServiceDeliverables_productizedService"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ServicePageReviews_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "77b051b7f909d1721739460f3bcf74aa";

export default node;
